import * as React from 'react';
import styled from "styled-components";
import {Button} from "../../styled"

import Image from './preview.png';
import {navigateTo} from "helpers/navigate-to";

const Content = styled.div`
  max-width: 430px;
`;

const ImageBox = styled.div`
  flex-grow: 1;
  height: 382px;
  max-width: 660px;

  img {
    width: 100%;
    object-fit: cover;
  }
`

const Title = styled.div`
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  letter-spacing: 0.01em;
`

const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.01em;
  margin-top: 18px;
  margin-bottom: 26px;
`

const Description = styled.div`
  margin-top: 30px;
  color: #4F4F51;
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0.01em;
`

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 50px 90px 28px;
  background: #F5F9FF;
  box-sizing: border-box;
  width: 100%;
  max-width: 1340px;
  border-radius: 20px;
  
  @media screen and (max-width: 1270px) {
    ${ImageBox} {
      margin: 40px auto;
      height: auto;
    }
  }
  
  @media screen and (max-width: 640px) {
    padding: 12px;
    
    ${Title} {
      font-size: 24px;
      font-weight: 500;
      line-height: 34px;
      letter-spacing: 0.01em;
    }
    
    ${SubTitle} {
      margin-top: 10px;
      margin-bottom: 14px;
    }
    
    ${ImageBox} {
      margin: 21px auto;
    }
    
    ${Description} {
      margin-top: 14px;
    }
  }
`;

/**
 * render landing page main section
 * @constructor
 */
export default function Main(): React.ReactElement {
  return (
    <Container>
      <Content>
        <Title>Новая платформа для онлайн обучения, которую Вы ждали</Title>
        <SubTitle>
          Самая удобная и эффективная платформа
          для создания образовательного контента
          и доставки до пользователя
          с максимальной конверсией
        </SubTitle>
        <Button onClick={() => navigateTo('register')}>Попробовать бесплатно</Button>
        <Description>
          *Действует ограничение:
          только первые 100 пользователей
        </Description>
      </Content>
      <ImageBox>
        <img src={Image} alt=""/>
      </ImageBox>
    </Container>
  );
}
